// extracted by mini-css-extract-plugin
export default {"container":"style_container__7h4+r","wrapper":"style_wrapper__Suxcn","panel":"style_panel__+kV04","pic":"style_pic__Nt8W7"};